// extracted by mini-css-extract-plugin
export default {"container":"TopCoin_container__U5iGs","content":"TopCoin_content__0t3xD","title":"TopCoin_title__hz+qc"};